import { render } from "./Inventory.vue?vue&type=template&id=59e9b603&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=59e9b603&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e9b603"]])

export default __exports__